import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useVisualViewportHeight } from '@leanpay/hooks'
import { A11yAnnouncer } from '@leanpay/ui'

import { useAppStore } from './app-store'
import ManageCookiesConsent from 'components/manage-cookies-consent/manage-cookies-consent'
import PrequalifyHeader from 'components/pre-qualify-header/pre-qualify-header'
import { isMarketRom, isMarketSlo } from 'library/constants'
import { useTrackPqStep } from 'library/hooks/use-track-pq-step'
import { lazyWithRetry } from 'library/lazy-with-retry'
import { handlePreQualifiedProgress, shouldShowCancelIcon } from 'library/utils'

const MainAppROM = lazyWithRetry(() => import('./pre-qualify-markets/rom/main-app-rom'))
const MainAppSLO = lazyWithRetry(() => import('./pre-qualify-markets/slo/main-app-slo'))

const MainLayout = () => {
    const location = useLocation()
    const { progress, setProgress, isAuthenticated, vendorToken } = useAppStore()
    useTrackPqStep()
    useVisualViewportHeight()

    useEffect(() => {
        handlePreQualifiedProgress(location.pathname, setProgress)
    }, [location.pathname, setProgress])

    const renderApp = () => {
        if (isMarketSlo) return <MainAppSLO />
        else if (isMarketRom) return <MainAppROM />

        throw Error('Error')
    }
    //Show cancel icon only if user is authenticated and screen is not one of the excluded paths
    const showCancelIcon = isAuthenticated && shouldShowCancelIcon()

    const showCookiesConsent = location.pathname === '/check-limit'

    return (
        <>
            <meta name="token" content={vendorToken} />

            <div className="main-layout flex-1 self-center flex flex-col items-center overflow-y-auto overscroll-none min-[900px]:scroll-smooth max-w-[840px] w-full bg-lp-grey2 rounded-lg min-[900px]:max-h-[95vh] min-[900px]:my-auto max-[899px]:rounded-none max-[899px]:max-w-full max-[899px]:h-full max-[899px]:pb-30">
                <A11yAnnouncer />
                <PrequalifyHeader showCancelIcon={showCancelIcon} progress={progress}>
                    {renderApp()}
                </PrequalifyHeader>
                {showCookiesConsent && <ManageCookiesConsent />}
            </div>
        </>
    )
}

export default MainLayout
